"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var Widget_1 = require("../tools/Widget");
var Tabs = (function (_super) {
    __extends(Tabs, _super);
    function Tabs(node, config) {
        var _this = _super.call(this, node, config) || this;
        _this.format();
        _this.el.on('click', '.tab', jquery_1.default.proxy(_this.handleClick, _this));
        return _this;
    }
    Tabs.prototype.handleClick = function (event) {
        this.setActive(this.getTabIndexForTab(event.target));
    };
    Tabs.prototype.format = function () {
        this.tabs = this.el.find('.tab');
        this.panels = this.el.find('.tab-content');
        var tabWrapper = jquery_1.default('<div class="tab-wrapper" />');
        this.el.prepend(tabWrapper);
        this.tabs.appendTo(tabWrapper);
        this.setActive(0);
    };
    Tabs.prototype.setActive = function (index) {
        if (!this.tabs[index]) {
            return;
        }
        this.tabs.removeClass('active');
        this.panels.removeClass('active');
        jquery_1.default(this.tabs[index]).addClass('active');
        jquery_1.default(this.panels[index]).addClass('active');
    };
    Tabs.prototype.getTabIndexForTab = function (tab) {
        var index = -1;
        this.tabs.each(function (i, element) {
            if (tab == element) {
                index = i;
            }
        });
        return index;
    };
    return Tabs;
}(Widget_1.Widget));
exports.Tabs = Tabs;
